<template>
  <div class="xs-12">
    <div class="dea-ico-copia-digitale"></div>
    <h2 class="dea-evaluation-modal__title dea-heading--medium__l" data-test="evaluation-modal-title">
      Richiedi copia digitale
    </h2>
    <div class="dea-heading--regular__ms">
      Valuta un libro del nostro catalogo! La tua richiesta arriverà alla tua agenzia di riferimento.
      <br />
      Abbiamo bisogno di qualche informazione prima di iniziare:
    </div>
    <div class="dea-heading--medium__ms dea-evaluation-modal__evaluation">Quale libro vuoi valutare?</div>
  </div>
</template>

<script>
export default {
  name: "EvaluationModalContent",
};
</script>
